import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";

import { css } from "styled-components";

const enum fields {
    id = "id",
    class = "class",
}

interface CustomFormStyles {
    mainContainer?: InjectableCss;
}

interface Props extends WidgetProps {
    fields: {
        id: string;
        class: string;
    };
}

export const customFormStyles: CustomFormStyles = {
    mainContainer: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: rgba(194, 197, 199);
            .contactFormCd {
                background: rgba(194, 197, 199);
                padding: 20px;
            }
            .contactFormCd .clickdform.mainDiv {
                max-width: 730px;
                margin: 0 auto;
                float: none;
            }
            .contactFormCd .clickdform select {
                height: 32px;
            }
            .contactFormCd .clickdform .maxSize1 {
                color: #595b5d !important;
                margin-bottom: 0.1875em !important;
            }
            .contactFormCd .responsiveCell.responsiveCellSize1 {
                text-align: left !important;
            }
            .contactFormCd .responsiveCell.responsiveCellSize1.emptyCell {
                display: none;
            }
            .buttonContainer input#btnSubmit {
                background-size: 100% 200%;
                background-image: linear-gradient(to bottom, ${getColor("primary")} 50%, ${getColor("primary")} 50%) !important;
                transition: background-position 0.2s ease-in-out, color 0.2s ease-in-out;
                font-family: "canada-type-gibson";
                font-weight: normal;
                background-color: ${getColor("primary")};
                padding: 0.5em 1.2em;
                text-decoration: none;
                box-shadow: none;
                border: 0;
                text-align: center;
                color: #fff !important;
                cursor: pointer;
            }
            .buttonContainer input#btnSubmit:hover {
                background-color: #931a1d;
                background-position: 0 100%;
            }
            .contactFormCd .responsiveCell.responsiveCellSize1.emptyCell {
                display: none;
            }
            .clickdform .responsiveCell div.alignBottom {
                display: table-cell;
            }
        `,
    },
};

const styles = customFormStyles;

const CustomGenericForm: React.FC<Props> = ({ fields, id }) => {
    return (
        <StyledWrapper {...styles.mainContainer}>
            <Zone contentId={id} zoneName="CustomGenericForm" />
            {parse(`<div pageID=${fields.id} class=${fields.class}></div>`, parserOptions)}
        </StyledWrapper>
    );
};

const definition: WidgetDefinition = {
    group: "Common",
    displayName: "Custom Generic Form",
    fieldDefinitions: [
        {
            name: fields.id,
            displayName: "ID",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            placeholder: "Enter URL",
            isRequired: true,
        },
        {
            name: fields.class,
            displayName: "Class",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            placeholder: "Enter URL",
        },
    ],
};

const widgetModule: WidgetModule = {
    component: CustomGenericForm,
    definition,
};

export default widgetModule;
